import { useQuery } from '@tanstack/react-query';
import { statisticsApi } from '@/api/statistics';

/**
 * Query key factory for statistics
 */
export const statisticsKeys = {
  all: ['statistics'] as const,
  usage: () => [...statisticsKeys.all, 'usage'] as const,
};

/**
 * Hook to fetch platform-wide usage statistics
 * Uses placeholderData to show cached data instantly on revisit
 */
export function useUsageStatistics() {
  return useQuery({
    queryKey: statisticsKeys.usage(),
    queryFn: () => statisticsApi.getUsage(),
    staleTime: 60000, // 1 minute
    placeholderData: (previousData) => previousData,
  });
}
